/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * KonnectHub REST API Documentation
 * OpenAPI spec version: latest
 */

/**
 */
export type FilterConditionOperator = typeof FilterConditionOperator[keyof typeof FilterConditionOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterConditionOperator = {
  eq: 'eq',
  neq: 'neq',
  isNull: 'isNull',
  isNotNull: 'isNotNull',
  in: 'in',
  nin: 'nin',
  contains: 'contains',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  gt: 'gt',
  gte: 'gte',
  lt: 'lt',
  lte: 'lte',
  includes: 'includes',
  every: 'every',
  some: 'some',
  isEmpty: 'isEmpty',
} as const;
